import axios from 'axios';

// As listagens do BPO RH não trazem mais senha, api_token, api_convenia nem
// webhook_secret — só `tem_<campo>`. O valor é buscado um a um por este helper,
// e o backend registra no log quem revelou o quê.
//
// tipo: 'servico' (senha | api_token) ou 'cliente' (api_convenia | webhook_secret)
export const buscarCredencial = (tipo, id, campo) => {
  const accessToken = localStorage.getItem('access');
  return axios
    .get(`${process.env.REACT_APP_API_BASE}/api/bporh-credencial/`, {
      params: { tipo, id, campo },
      headers: { Authorization: `Bearer ${accessToken}` },
    })
    .then((res) => res.data.valor || '');
};

// Copia para a área de transferência. `navigator.clipboard` não existe fora de
// contexto seguro (http:// que não seja localhost) e lança de forma síncrona,
// por isso a checagem antes do writeText.
export const copiarParaClipboard = (texto) => {
  if (!texto) return Promise.reject(new Error('nada a copiar'));
  if (!navigator.clipboard?.writeText) {
    return Promise.reject(new Error('O navegador não permite copiar nesta conexão'));
  }
  return navigator.clipboard.writeText(texto);
};
